module.exports = __webpack_public_path__ + "img/Upload.938c55c0.png";